<template>
    <div class="md-layout">
        <div class="md-layout-item md-small-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>Work Done</md-icon>
                    </div>
                    <h4 class="title">Edit Work</h4>
                </md-card-header>

                <form @submit.prevent="update">
                    <md-card-content>
                        <div class="text-right">
                            <md-button @click="goBack" class="md-primary md-dense">
                                Back to List
                            </md-button>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Name
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="work.name" />
                                    <validation-error :errors="apiValidationErrors.name" />
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Call ID
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="work.call_id" />
                                    <validation-error :errors="apiValidationErrors.call_id" />
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Vessel
                            </label>
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Select ...</label>
                                    <md-select v-model="work.vessel.id" name="vessels">
                                        <md-option
                                                v-for="vessel in available_vessels_dropdown"
                                                :key="vessel.id"
                                                :value="vessel.id"
                                        >
                                            {{ vessel.name }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Activity Guidance
                            </label>
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Select ...</label>
                                    <md-select v-model="work.guidance.id" name="guidances">
                                        <md-option
                                                v-for="guidance in available_guidances_dropdown"
                                                :key="guidance.id"
                                                :value="guidance.id"
                                        >
                                            {{ guidance.name }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                        </div>
                    </md-card-content>

                    <md-card-actions md-alignment="right">
                        <md-button type="submit" class="md-success">Update Work</md-button>
                    </md-card-actions>
                </form>
            </md-card>
        </div>
    </div>
</template>

<script>
import { ValidationError } from '@/components';
import formMixin from '@/mixins/form-mixin';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CKEditor from '@ckeditor/ckeditor5-vue';
import service from '@/store/services/settings/activities-service';

export default {
    components: { ValidationError },

    mixins: [formMixin],

    data: () => ({
        work: {
            type: 'works',
            name: null,
            call_id: null,
            vessel: {
                id: null,
                type: 'vessels',
            },
            guidance: {
                id: null,
                type: 'guidances',
            },
            relationshipNames: ['vessel','guidance'],
        },
        available_vessels_dropdown: [],
        available_guidances_dropdown: [],

    }),

    created () {
        this.get();
        this.getVessels();
        this.getGuidances();
    },
    methods: {
        async get () {
            try {
                const id = this.$route.params.id;
                // return service.get(id)
                //     .then((response)=>{
                //         console.log(response);
                //     });
                // console.log(this.$store.dispatch("activities/get", id));
                await this.$store.dispatch('works/get', id);
                // console.log(this.$store.getters)
                this.work = this.$store.getters['works/work'];
                console.log(this.work);
            } catch (e) {
                await this.$store.dispatch(
                    'alerts/error',
                    'Oops, something went wrong!'
                );
            }
        },

        async update () {
            if (
                this.$isDemo == 1 &&
                    ['1', '2', '3'].includes(this.$route.params.id)
            ) {
                await this.$store.dispatch(
                    'alerts/error',
                    'You are not allowed to change data of default roles.'
                );
                return;
            }
            try {
                await this.$store.dispatch('works/update', this.work);
                await this.$store.dispatch(
                    'alerts/success',
                    'Work Done updated successfully.'
                );
                this.goBack();
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.$store.dispatch(
                        'alerts/error',
                        e.response.data.errors[0].detail
                    );
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.$store.dispatch(
                        'alerts/error',
                        'Oops, something went wrong!'
                    );
                }
            }
        },
        getVessels () {
            this.$store.dispatch('vessels/list').then(() => {
                //  console.log(this.$store)
                this.available_vessels_dropdown = this.$store.getters['vessels/dropdown'];
                console.log(this.available_vessels_dropdown);
            });
        }, getGuidances () {
            this.$store.dispatch('guidances/list').then(() => {
                this.available_guidances_dropdown = this.$store.getters['guidances/dropdown'];
            });
        },

        goBack () {
            this.$router.push({ name: 'Works List' });
        },
    },
};
</script>
